import Navbar from "../../components/common/Navbar.js";
import Header from "../../components/common/Header.js";
import SearchUser from "../../components/transfers/SearchUser";
import Footer from "../../components/common/Footer.js";

const Transfers = ({}) => {
  return (
    <>
      <Navbar />
      <Header title={"Transfer Market"} />

      <div className="container body">
        <div className="row">
          <SearchUser />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Transfers;
